module.exports = __webpack_public_path__ + "static/media/md-bonfire.fe5a8134.svg";